export const SOCIAL_POST_IMAGE_SIZE_LIMIT = 8 * 1024 * 1024;
export const SOCIAL_POST_VIDEO_SIZE_LIMIT = 100 * 1024 * 1024;

export enum SocialPostStatus {
  POSTED = 'posted',
  SCHEDULED = 'scheduled',
  FAILED = 'failed',
  RESCHEDULE_REQUIRED = 'reschedule-required',
}
